<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
    <div class="call-to-action">
      <SmartLinkElement
        :codename="contentTypes.hero.elements.title.codename"
      >
        <MyLink :to="href" class="btn btn-primary" :target="linkTarget">
          {{ model.elements.linkTitle.value }}
        </MyLink>
      </SmartLinkElement>
    </div>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { contentTypes } from '~/models'
import type { CallToActionModel } from '~/models'
import { useCtaLink } from '~/composables/useCtaLink'
const props = defineProps<{ model: CallToActionModel }>()
const href = computed(() => useCtaLink(props.model))
// Mirrors useCtaLink precedence: the manual target only wins when no linked item or asset is set.
const isManualTarget = computed(() => {
  const { linkedTarget, genericAssetTarget, manualTarget } = props.model.elements
  return !linkedTarget.value?.length && !genericAssetTarget.value?.length && !!manualTarget.value
})
// External (manual) links honor the Open in New Tab toggle, defaulting to the same tab (e.g. OCF links).
// Linked pages, assets and emails keep the automatic behavior (assets always open in a new tab).
const linkTarget = computed(() => {
  if (isManualTarget.value) {
    return multipleChoiceToBoolean(props.model.elements.openInNewTab) ? '_blank' : '_self'
  }
  return getLinkTarget(false, href.value)
})
</script>
